import React from 'react';

import {ContentWrapper} from '../../Layout';
import PopupFullPage from '../../Popup/PopupFullPage';
import {Article} from '..';

const ErrorModalTemplate = (props) => {
    return (
        <PopupFullPage>
            <ContentWrapper className='py-10 lg:pt-[88px]'>
                <Article error {...props} />
            </ContentWrapper>
        </PopupFullPage>
    );
};

export default ErrorModalTemplate;
